// extracted by mini-css-extract-plugin
export var emailBlockLink = "_ov-0";